export const ANIA_ENUM = {
  ANIA_LEGEND: -1, // For legend (1,2,3) rendering only, never stored
  ANIA_NONE: 0, // Turned off
  ANIA_01: 1, // Wind 1,2,3
  ANIA_02: 2, // Grandine 1,2,3
  ANIA_03: 3, // Fulmini 1,2,3
  ANIA_04: 4, // Precipitazione_75 1,2,3
  ANIA_05: 5, // Precipitazione_Nevosa_30 1,2,3
  ANIA_ARRAY_LENGTH: 6, // should fit [ANIA_NONE,ANIA_01,ANIA_02,ANIA_03,ANIA_04,ANIA_05] and position ANIA_NONE (0) in the array is left unused.
};

export const AniaPermissionNames = [
  "super",
  "ANIA_RISK_CARTAPERICOLOSITAVENTO",
  "ANIA_RISK_GRANDINE",
  "ANIA_RISK_FULMINI",
  "ANIA_RISK_PRECIPITAZIONE75",
  "ANIA_RISK_PRECIPITAZIONE_NEVOSA_30",
  "ANIA_NOT_USED",
];
